import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import styled, { css, keyframes } from "styled-components";

import { TOING_HEADER_BANNER_SLIDE_UP_DELAY_MS, TOING_HEADER_BANNER_SLIDE_UP_DURATION_MS } from "./constants";

const slideUpAnimationTiming = `${TOING_HEADER_BANNER_SLIDE_UP_DURATION_MS}ms ease ${TOING_HEADER_BANNER_SLIDE_UP_DELAY_MS}ms both`;

export const POP_IN_DURATION_MS = 480;

export const SHIMMER_SWEEP_DURATION_MS = 800;

export const SAVINGS_TEXT_SHIMMER_DELAY_MS =
    TOING_HEADER_BANNER_SLIDE_UP_DELAY_MS + TOING_HEADER_BANNER_SLIDE_UP_DURATION_MS + POP_IN_DURATION_MS;

const savingsTextGradientShimmerSweep = keyframes`
    0% {
        background-position: 100% center;
    }
    100% {
        background-position: 0% center;
    }
`;

export const rootSlideUp = keyframes`
    0% {
        transform: translateY(100px);
    }
    100% {
        transform: translateY(0);
    }
`;

export const slideUp = keyframes`
    0% {
        transform: translateY(100px);
    }
    80% {
        transform: translateY(-10px);
    }
    100% {
        transform: translateY(0);
    }
`;

export const popIn = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.35);
    }
    65% {
        opacity: 1;
        transform: scale(1.08);
    }
    100% {
        transform: scale(1);
    }
`;

export const Root = styled.div<{ $animate: boolean }>`
    position: relative;
    width: 100%;
    ${({ $animate }) =>
        $animate
            ? css`
                  animation: ${rootSlideUp} ${slideUpAnimationTiming};
              `
            : css`
                  animation: none;
              `}
`;

export const BackgroundLayer = styled.div({
    position: "relative",
    zIndex: 0,
    width: "100%",
    lineHeight: 0,
});

export const AnimatedInner = styled.div<{ $animate: boolean }>`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    ${({ $animate }) =>
        $animate
            ? css`
                  animation: ${slideUp} ${slideUpAnimationTiming};
              `
            : css`
                  animation: none;
              `}
`;

export const Overlay = styled.div<{ $hasSavingsText?: boolean }>(({ theme, $hasSavingsText }) => ({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    paddingTop: $hasSavingsText ? theme.spacing.xxSmall : theme.spacing.medium,
    paddingBottom: theme.spacing.xSmall,
    boxSizing: "border-box",
}));

export const StyledBackgroundImage = styled(Image)({
    width: "100%",
    height: "150px",
    objectFit: "unset",
});

export const SavingsTextShimmerWrap = styled.span({
    position: "relative",
    display: "inline-block",
    verticalAlign: "bottom",
    maxWidth: "100%",
});

export const StyledSavingsText = styled(Text)<{ $shimmer?: boolean }>`
    text-transform: uppercase;
    padding-left: ${({ theme }) => theme.spacing.x15};
    margin-bottom: ${({ theme }) => theme.spacing.xxxSmall};
    position: relative;
    z-index: 1;

    ${({ theme, $shimmer }) => {
        if (!$shimmer) {
            return css``;
        }
        const textColor = theme.colors[theme.colorMode].text_inverse_Med_Emphasis;
        return css`
            -webkit-text-fill-color: transparent;
            background-image: linear-gradient(
                90deg,
                ${textColor} 0%,
                ${textColor} 38%,
                #dbff00 50%,
                ${textColor} 62%,
                ${textColor} 100%
            );
            background-size: 300% 100%;
            background-position: 100% center;
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            background-repeat: no-repeat;
            animation: ${savingsTextGradientShimmerSweep} ${SHIMMER_SWEEP_DURATION_MS}ms ease-out
                ${SAVINGS_TEXT_SHIMMER_DELAY_MS}ms both;
        `;
    }}
`;

export const DashedDivider = styled.div({
    border: "0.9px solid transparent",
    borderImage: "repeating-linear-gradient(to right, #018029 0, #018029 4px, transparent 4px, transparent 8px) 1",
});

export const BodyCopyBlock = styled.div<{ $hasSavingsText?: boolean }>(({ theme, $hasSavingsText }) => ({
    paddingLeft: theme.spacing.x15,
    marginTop: $hasSavingsText ? theme.spacing.small : theme.spacing.xSmall,
}));

export const DashedDividerWrapper = styled.div({
    width: "100%",
    margin: "0 auto",
    paddingLeft: "12px",
    paddingRight: "12px",
    paddingTop: "4px",
});
